import axios from 'axios'

/**
 * Function to get registrered users
 * @param {Number} page
 * @param {String} status
 */
export const getUsersbyClient = (status) => {
  return axios.get(`${process.env.API_URL}/userlist/${status}/status`)
}

/**
 * Function to get registrered users
 * @param {Number} page
 * @param {String} status
 */
export const getUser = (id, status = 'PENDING') => {
  return axios.get(`${process.env.API_URL}/user/${id}/info`)
}

/**
 * Function to update status by user id
 * @param {Integer} id
 * @param {String} status
 * @return AxiosPromise
 */
export const updateUserStatus = (id, status) => {
  return axios.put(`${process.env.API_URL}/user/${id}/status`, {status})
}

/**
 * Function to update status by user id
 * @param {payload} object
 * @return AxiosPromise
 */
export const saveUser = (data) => {

  console.log(data)
  let username = data.email.split("@")
  let payload = {
    "username": username[0],
    "email": data.email,
    "password": "Password#P4ssw0rd",
    "name": data.name
  }

  return axios.post(`${process.env.API_URL}/auth/local/register`, payload, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

/**
 * Function to update status by user id
 * @param {payload} object
 * @return AxiosPromise
 */
export const updateUser = (payload) => {
  return axios.put(`${process.env.API_URL}/user/update`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

/**
 * Function to update status by user id
 * @param {payload} object
 * @return AxiosPromise
 */
export const getRol = (id, status = 1) => {
  return axios.get(`${process.env.API_URL}/userlist/${id}/client/${status}/status`)
}

/**
 * Function to know if the user is authenticated
 * @return Boolean
 */
export const getListAccounts = () => {
  return axios.get(`${process.env.API_URL}/userlist/clients`)
}

/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const setClient = (payload) => {
  return axios.post(`${process.env.API_URL}/setclient`, payload)
}

/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const resendMail = (payload) => {
  return axios.post(`${process.env.API_URL}/resendmail`, payload)
}

/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const getAccessInfoUser = (payload) => {
  return axios.post(`${process.env.API_URL}/acls/info-user`, payload)
}

/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const saveAccessInfoUser = (payload) => {
  return axios.post(`${process.env.API_URL}/acls/save`, payload)
}

/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const updateAccessInfoUser = (payload) => {
  return axios.post(`${process.env.API_URL}/acls/update`, payload)
}

/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const getAccessUser = () => {
  return axios.post(`${process.env.API_URL}/acls/info`)
}

/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const setTokenSend = (payload) => {
  return axios.post(`${process.env.API_URL}/user/recoverypwd`, payload)
}
